import React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';

const Table = ({ blok }) => {
  return (
    <div
      className="col-span-12 mt-12 pl-4 md:pl-8"
      {...storyblokEditable(blok)}
      key={blok._uid}
    >
      <div className="w-full max-w-screen-xl mx-auto">
        <h3>{blok.heading}</h3>
      </div>
      <div className="w-full max-w-screen-xl mx-auto overflow-auto no-scrollbar">
        <table className="w-full  min-w-[640px]">
          <thead>
            <tr className="py-4 px-0 border-b-[1px] border-black-12.5 flex justify-between font-bold ">
              {blok.table.thead.map((th, index) => (
                <th
                  className={` ${
                    index === blok.table.thead.length - 1
                      ? 'text-left w-1/3'
                      : 'text-left w-1/3'
                  }`}
                  key={index}
                >
                  {th.value}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {blok.table.tbody.map((tr, index) => (
              <tr
                className="py-4 px-0 border-b-[1px] border-black-12.5 flex justify-between "
                key={index}
              >
                {tr.body.map((td, index) => (
                  <td
                    className={`min-w-48  ${
                      index === tr.body.length - 1
                        ? 'text-left w-1/3 '
                        : 'text-left w-1/3'
                    }`}
                    key={index}
                  >
                    {td.value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
